import { EditTabsPattern } from '@/components'
import { useComponentProvider } from '@/components/ViewComponentModal/ViewComponentProvider'
import { useSchema } from '@/hooks'

import { ConfigData, Conversation, History, Settings } from './tabs'

export const DataIntake = () => {
  const { componentID, useUrl } = useComponentProvider()
  useSchema({ name: 'DataIntakeConfig', version: '2.1.0' })
  const tabs = [
    { component: <Settings />, name: 'settings' },
    { component: <Conversation />, name: 'conversation' },
    { component: <History />, name: 'version' },
    { component: <ConfigData />, name: 'config' },
  ]
  return (
    <EditTabsPattern
      defaultTab="settings"
      showTabs={!!componentID}
      tabs={tabs}
      urlParams={useUrl}
    />
  )
}
